export enum LargeNumberEnum {
  THOUSAND = 1000,
  MILLION = 1000000,
  BILLION = 1000000000,
  TRILLION = 1000000000000,
  QUADRILLION = 1000000000000000,
}
